/* eslint-disable camelcase */
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import Byline from '@components/byline'
import { Series } from '@components/atoms'
import { Root } from './story-header.styles'

const ArticleHeader = ({
  archive,
  headline,
  published,
  author,
  cat,
  created_date,
  category,
}) => {
  return (
    <Root mt={[3, 6, 10]} mb={[2, 3, 6]} px={[1, 2, 3]}>
      {cat
       && (
         <Series data-gtm-category={cat.series || cat.category}>
           {cat.series || cat.category}
         </Series>
       )
      }
      {!cat && archive && <Series data-gtm-category={category}>{category || 'PGA Archive'}</Series>}
      <Typography
        variant="h3"
        component="h1"
        gutterBottom
        data-gtm-story={headline}
        data-cy="article-headline"
      >
        {headline}
      </Typography>
      {(published || created_date || author)
        && <Byline published={published || created_date} author={author} />
      }
    </Root>
  )
}

ArticleHeader.propTypes = {
  /** Adapt component for legacy data props */
  archive: PropTypes.bool,
  /** The main headline of the article */
  headline: PropTypes.string.isRequired,
  /** Optional. Category displayed above the headline */
  /** Date() of publishing */
  published: PropTypes.string,
  /** Optional, displays if provided */
  author: PropTypes.string,
  cat: PropTypes.shape({
    category: PropTypes.string,
    series: PropTypes.string,
  }),
  created_date: PropTypes.string,
  category: PropTypes.string,
}

export default ArticleHeader
